export const locale = {
    lang: "en",
    data: {
      host: {
        chooseDomain: "اختيار نطاق",
        addToCard: "اضافه الي العربه",
        DomainsPrices: "اسعار النطاقات",
        transfer: "نقل",
        takenMessage: "هذا النطاق محجوز من قبل اذا كنت تمتلكه يمكنك نقله الان.",
      },
      general: {
        required: "مطلوب",
        minlength: "يجب ان يكون عدد الاحرف اكثر من ",
      },
      global: {
        sorry: "اسف",
        telegram: "التليجرام",
        confirm: "تحقق",
        refresh: "تحديث",
      },
      senders: {
        support: {
          confirm_payment_sender_names: "تأكيد سداد اسماء الارسال",
          confirm_payment_balance_charge: "تأكيد سداد  شحن الرصيد",
          sender_name: "اختر اسم المرسل",
          cost: "التكلفة",
          sender_name_count: "عدد اسماء الارسال",
          sender_name_cost: "تكلفة الاسم",
          tax: "الضريبة",
          total: "الاجمالي",
          bank: "اختر البنك",
          bank_details: "تفاصيل البنك",
          depositor_bank: "البنك المحول منه",
          depositor_name: "اسم المودع",
          depositor_number: "رقم حساب المودع",
          deposit_date: "تاريخ الايداع",
          deposit_receipt: "صورة الايداع",
          ticket_details: "تفاصيل التذكرة",
          tickets: {
            
            sender_name: "اسماء الارسال",
             bank:"محول الى",
            title:'تذاكر الدعم ',
            sales: "المبيعات",
            email: "البريد الالكتروني",
            add: "اضافة تذكرة",
            mobile: "الجوال",
            depositor_bank:"بنك العميل",
            depositor_name: "اسم المودع",
            ticket_status:"حالة التذكرة",
            department:"القسم",
            confirmation_payment_sender: "تأكيد سداد اسم المرسل",
            lastReply: "اخر رد",
            lastReplyTime: "وقت اخر رد",
            type: {
              pending: "غير مؤكد الدفع",
              done: "مؤكدة",
              refuse: "مرفوض",
            },
          },
        },
      },
    },
  };
  